<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="timeslotValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <time-input class="mb-3"
                :label="$t('logs.time')"
                label-classes="form-control-label required"
                v-model="value.time"
                name="time"
                rules="required"
                :error="errors.get('time')">
            </time-input>

            <base-input class="mb-3"
                :label="$t('timeslots.summary')"
                :placeholder="$t('timeslots.summary')"
                v-model="value.instructor_summary"
                name="instructor_summary"
                :error="errors.get('instructor_summary')">
            </base-input>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },
            
            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },
        },

        created() {
            this.errors.setValidator('timeslotValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
